// extracted by mini-css-extract-plugin
export default {"wrap":"SearchInput_wrap__Bly16"};